import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { DialogService } from '@ngneat/dialog';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { AnonymousFeedbackModalComponent } from '../anonymous-feedback-modal/anonymous-feedback-modal.component';

@Component({
  selector: 'app-ask-feedback-button',
  templateUrl: './ask-feedback-button.component.html',
  styleUrls: ['./ask-feedback-button.component.scss'],
  standalone: true,
  imports: [CommonModule, NgxTolgeeModule]
})
export class AskFeedbackButtonComponent {
  constructor(private dialog: DialogService) {}

  openFeedbackModal(): void {
    this.dialog.open(AnonymousFeedbackModalComponent, {
      size: 'lg',
      enableClose: true,
      closeButton: false,
    });
  }
}





